import { styled } from 'stitches.config'

export const PostCardImage = styled('div', {
  display: 'flex',

  img: {
    borderTopRightRadius: '22px',
    borderTopLeftRadius: '22px',
  },
})

export const PostCardContent = styled('div', {
  padding: '$3',
  paddingBottom: '$4',
  color: '$accent-black',
  borderBottomRightRadius: '22px',
  borderBottomLeftRadius: '22px',
  overflow: 'hidden',

  '@bp2': {
    paddingRight: '$5',
  },

  '& .wrapper': {
    position: 'relative',
    overflow: 'hidden',
    height: '208px',
  },
})

export const PostCardRoot = styled('a', {
  cursor: 'pointer',
  maxWidth: '327px',
  backgroundColor: '$$cardColor',
  borderRadius: '22px',
  justifySelf: 'center',

  '@bp2': {
    maxWidth: '377px',
  },

  '& img': {
    borderBottom: '4px solid $$borderColor',
  },

  variants: {
    variant: {
      white: {
        $$cardColor: '$colors$accent-white',
        $$borderColor: '$colors$primary-500',
      },
      neutral: {
        $$cardColor: '$colors$accent-white',
        $$borderColor: '$colors$primary-700',
      },
      'secondary-light': {
        $$cardColor: '$colors$tertiary-200',
        $$borderColor: '$colors$accent-white',
      },
      'secondary-dark': {
        $$cardColor: '$colors$tertiary-200',
        $$borderColor: '$colors$primary-600',
      },
    },
    masonry: {
      true: {
        '@bp3': {
          '&:not(:nth-child(3n+2))': {
            position: 'relative',
            top: '$6',
          },
        },
      },
    },
  },
  defaultVariants: {
    masonry: true,
    variant: 'white',
  },
})
